module.exports = __webpack_public_path__ + "img/nda-restricted-booth.7e287860.jpg";